import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { SessionManager } from "@/components/auth/SessionManager";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { pathname } = useLocation();

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      {/* key on pathname => subtle enter transition on route change */}
      <main key={pathname} className="flex-1 page-enter">
        {children}
      </main>
      <Footer />
      {/* Session timeout manager - shows warning before expiration */}
      <SessionManager />
    </div>
  );
};

export default Layout;
